import React from 'react';
import { PlanCards } from './PlanCards';
import { Emoji } from './Emoji';
import { useCountdown } from '../hooks/useCountdown';
export function Oferta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section id="planes" className="w-full" data-id="element-137" data-mp="ji02ns5t07bz">
      <div className="w-full bg-[#1b0705] py-12 sm:py-14" data-id="element-138" data-mp="3ivke3wnmyhn1">
        <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6" data-id="element-139" data-mp="3ixdj77ilotsx">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.25rem,5.5vw,1.875rem)] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-140" data-mp="3nudqflr6s2lm">
            <Emoji symbol="⏰" data-id="element-141" data-mp="qpehirgq8ns" />
            Precio de lanzamiento — cierra en:
          </h2>

          <div className="mt-7 flex items-start justify-center gap-2 sm:gap-6" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-142" data-mp="174yeudmw4t43">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-143" data-mp="1it26l4fju5ss" data-mpi={index}>
                <div data-id="element-144" data-mp="1dt61t2z12ac6">
                  <span className="block font-display text-[clamp(2.25rem,12vw,4.5rem)] font-black leading-none tabular-nums text-[#e04b3c]" data-id="element-145" data-mp="1dsmtmdz6j0bc">
                    {unit.value}
                  </span>
                  <span className="mt-2 block font-display text-[11px] font-bold uppercase tracking-[0.14em] text-white/55 sm:text-sm" data-id="element-146" data-mp="14szr1ouprogp">
                    {unit.label}
                  </span>
                </div>
                {index < units.length - 1 ? <span className="font-display text-[clamp(2.25rem,12vw,4.5rem)] font-black leading-none text-[#e04b3c]" data-id="element-147" data-mp="v0lrn2r3ytxp">
                    :
                  </span> : null}
              </React.Fragment>)}
          </div>

          <p className="mt-7 inline-flex flex-wrap items-center justify-center gap-2 font-display text-[14px] font-bold text-white sm:text-xl" data-id="element-148" data-mp="h4gid87r59o3">
            <Emoji symbol="⚠️" data-id="element-149" data-mp="bh4xseke8d9t" />
            Después sube <span className="text-[#e04b3c]" data-id="element-150" data-mp="bi7ksbelhvkg">$10.000 ARS</span>. No
            vuelve.
          </p>

          <div className="mt-9" data-id="element-151" data-mp="3tnsyztcboga7">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1" data-id="element-152" data-mp="3touf4c873sys">
              <span className="inline-flex items-center gap-2 font-display text-[12px] font-bold text-[#e04b3c] sm:text-base" data-id="element-153" data-mp="2gq9r7g1ok2m">
                <Emoji symbol="🔴" data-id="element-154" data-mp="u7mlu5ua6kou" />
                Cupos al precio de lanzamiento
              </span>
              <span className="font-display text-[12px] font-extrabold text-white sm:text-base" data-id="element-155" data-mp="gghjgvzj3eat">
                Quedan pocos
              </span>
            </div>
            <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white/10 sm:h-3.5" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-156" data-mp="ldhrvdjuot53">
              <span className="block h-full w-[72%] rounded-full bg-[#e04b3c]" data-id="element-157" data-mp="1n82o7uhyyd4u" />
            </div>
            <p className="mt-3 text-right text-[12px] text-white/55 sm:text-sm" data-id="element-158" data-mp="1j70t9pv34n8o">
              72% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>
      </div>

      <div className="w-full bg-forest-900 py-14 sm:py-16" data-id="element-159" data-mp="14bky1hirqlap">
        <div className="mx-auto w-full max-w-[680px] px-4 sm:px-6 lg:max-w-content" data-id="element-160" data-mp="14c30wwzxrxrl">
          <h2 className="text-center font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold uppercase tracking-tight text-cream" data-id="element-161" data-mp="10bas24uz7uvu">
            Elegí tu <span className="text-lime-400" data-id="element-162" data-mp="1e7e9exkr48qw">Mega Pack</span>
          </h2>

          <div className="mt-10 sm:mt-12" data-id="element-163" data-mp="199cpkafi45ed">
            <PlanCards data-id="element-164" data-mp="2pons3hw22wr5" />
          </div>
        </div>
      </div>
    </section>;
}